import React, { useContext,useEffect,useState } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import axios from 'axios';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

import {
	IconButton,
	Typography,
	Card,
	CardContent,
	CardMedia,
	Tooltip,
	TextField,
	Accordion,
	AccordionSummary,
	AccordionDetails,
	Grid
} from "@material-ui/core";

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import GetAppIcon from '@material-ui/icons/GetApp';

import PushCreditFileButton from "./PushCreditFileButton";

import { UserContext } from "../../contexts/UserContext";

const useStyles = makeStyles((theme) => ({
	root: {
		maxWidth: 1000,
		marginTop: theme.spacing(3)
	},
	media: {
		height: 120,
		backgroundSize: "contain"
	},
	cardTitle: {
		display: "block",
		width: "100%",
		textOverflow:"ellipsis"
	},
	descriptionField: {
		width: 300,
		fontSize: "150%",
		marginLeft: theme.spacing(2)
	},
	accordionDetailsWithTabs: {
		display:"block"
	},
	descriptionPaper: theme.descriptionPaper,
	progress: theme.progress
}));

export default function CreditFilesStart(
	{
		channel,
		availableFiles,
		metafield,
		credit_id
	}) {
	const theme = useTheme();
	const classes = useStyles();
	const userContext = useContext(UserContext);
	const [files, setFiles] = useState({
		unused: {
			files: []
		},
		file1: {
			files: [],
			description: "Antrag, Kreditnehmer & Eigenmittel"
		},
		file2: {
			files: [],
			description: "Liegenschaft(en)"
		},
		file3: {
			files: [],
			description: "..."
		},
		file4: {
			files: [],
			description: "..."
		},
		file5: {
			files: [],
			description: "..."
		},
	});
	const [saveTimeout, setSaveTimeout] = useState(null);
	const [forcePreviewRefresh, setForcePreviewRefresh] = useState(1);// just increment if needed to expire cache
	

	useEffect(() => {
		const newAvailableMetaKeys = [];
		Object.keys(availableFiles).forEach((field_group_key) => {
			availableFiles[field_group_key].fields.forEach((field, index) => {
				newAvailableMetaKeys.push(field.meta_key);
				if (Object.keys(files).every(list_key => !files[list_key].files.includes(field.meta_key))) {
					// contained in no list (not even in "unused")
					setFiles(files => {
						files.unused.files.push(field.meta_key);
						return {...files};
					});
				}
			})
		});
		Object.keys(files).forEach(list_key => {
			files[list_key].files.forEach((meta_key,index) => {
				if (!newAvailableMetaKeys.includes(meta_key)) {
					// a list contains a key which doesn't exist anymore => remove it
					setFiles(files => {
						files[list_key].files.splice(index, 1);
						return {...files};
					});
				}
			})
		})
	}, [availableFiles]);
	

	useEffect(() => {
		try {
			const newFiles = JSON.parse(metafield.meta_value);
			if( newFiles )
				setFiles(newFiles);
		} catch (e) {
			console.log("JSON konnte nicht gelesen werden")
		}
	},[metafield])

	const saveFileSubmissionSettings = () => {
		// return early if metafield is not defined yet
		if (!metafield)
			return;

		const options = {
			url: `${process.env.REACT_APP_API_SERVICE_URL}/metafields/${metafield.id}`,
			data: {
				id: metafield.id,
				meta_value: JSON.stringify(files)
			},
      method: 'put',
      headers: userContext.getRequestAuthHeader()
		};
    axios(options)
      .then((res) => {
        //
      })
			.catch((err) => {
				console.log(err);
				pageContext.setErrorMessage("Das Feld konnte nicht gespeichert werden!");
			});
	}


	const saveDelayed = () => {
    if (saveTimeout)
      clearTimeout(saveTimeout);
    setSaveTimeout(setTimeout(() => saveFileSubmissionSettings(), 1000));
  }

	const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: 'none',
    marginRight: theme.spacing(1),
    // change background colour if dragging
    background: isDragging ? "#e0f2f1" : 'white',
		width: 180,
		minWidth:180,
    // styles we need to apply on draggables
    ...draggableStyle
	});
	
	const getListStyle = isDraggingOver => ({
		background: isDraggingOver ? '#e0e0e0' : '#eeeeee',
		padding: theme.spacing(1),
		display: "flex",
		overflowX: "scroll",
		height:260
	});

	const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
	};
	
	const move = (source, destination, droppableSource, droppableDestination) => {
    const sourceClone = Array.from(source);
    const destClone = Array.from(destination);
    const [removed] = sourceClone.splice(droppableSource.index, 1);

    destClone.splice(droppableDestination.index, 0, removed);

		setFiles(files => {
			files[droppableSource.droppableId].files = sourceClone;
			files[droppableDestination.droppableId].files = destClone;
			return {...files};
		});
	};
	

	const onDragEnd = ({ source, destination }) => {
		// dropped outside the list
		if (!destination) {
				return;
		}

		if (source.droppableId === destination.droppableId) {
			const items = reorder(
					files[source.droppableId].files,
					source.index,
					destination.index
			);
			setFiles(files => {
				files[source.droppableId].files = items;
				return {...files};
			});
		} else {
			move(
					files[source.droppableId].files,
					files[destination.droppableId].files,
					source,
					destination
			);
		}
		setForcePreviewRefresh(forcePreviewRefresh => forcePreviewRefresh + 1);
		saveDelayed();
	};



	return (
		<Accordion TransitionProps={{ unmountOnExit: true }} key={channel.channel_shortname}>
			<AccordionSummary
				expandIcon={<ExpandMoreIcon />}
			>
				<Grid container spacing={0} alignItems="center">
					<Grid item xs={8}>
						<Typography variant="h5">START:Bausparkasse</Typography>
					</Grid>
					<Grid item xs={4} align="right">
						<PushCreditFileButton
							caption="Alle senden"
							channel_shortname={channel.channel_shortname}
							channel_display_name="START:Bausparkasse"
							credit_id={credit_id}
							file_key="all"
						/>
					</Grid>
				</Grid>
			</AccordionSummary>
			<AccordionDetails className={classes.accordionDetailsWithTabs}>
				<Typography>Bei der START:Bausparkasse können nur 5 Dokumente hochgeladen werden, daher müssen die Daten sinnvoll zusammen gefasst werden.</Typography>
				<Typography>Zieh die einzelnen Dokumente einfach unten in die Listen für die maximal fünf Dateien. So wie du die Dateien anordnest, werden sie dann als einzelne Datei erstellt und übertragen.</Typography>
				<br />
				<DragDropContext onDragEnd={onDragEnd}>
					{Object.keys(files).map((list_key, i) => (
						<Droppable droppableId={list_key} key={list_key} direction="horizontal">
							{(provided, snapshot) => (
								<>
									<br />
									<Typography variant="h5">
										{list_key === "unused" ? "Verfügbare Dokumente" : "Datei " + i}
										{list_key !== "unused"
											&&
											<TextField
												className={classes.descriptionField}
												value={files[list_key].description ? files[list_key].description : null}
												onChange={(e) => {
													setFiles(files => {
														files[list_key].description = e.target.value;
														return { ...files };
													});
													saveDelayed();
												}} />
										}
										{list_key !== "unused" && files[list_key] && files[list_key].files.length > 0 &&
											<>
												<Tooltip title="Download">
													<IconButton
														size="small"
														style={{ marginLeft: 15 }}
														download
														target="_blank"
														href={`${process.env.REACT_APP_API_SERVICE_URL}/fileuploads/merged/meta/${metafield.id}/${channel.channel_shortname}-${list_key}.pdf?token=${userContext.accessToken}&listkey=${list_key}&v=${forcePreviewRefresh}`}>
														<GetAppIcon />
													</IconButton>
												</Tooltip>
												<PushCreditFileButton
													caption="Senden"
													channel_shortname={channel.channel_shortname}
													channel_display_name="START:Bausparkasse"
													credit_id={credit_id}
													file_key={list_key}
												/>
											</>}
									</Typography>
									<div
										ref={provided.innerRef}
										style={getListStyle(snapshot.isDraggingOver)}>
										{files[list_key].files.map((meta_key, index) => {
											let field_group = null;
											let field = null;
											Object.keys(availableFiles).some((field_group_key) => {
												const field_match = availableFiles[field_group_key].fields.find((field, index) => field.meta_key === meta_key);
												if (field_match) {
													field = field_match;
													field_group = availableFiles[field_group_key];
													return true;
												}
												return false;
											});
											if (!field)
												return null;
											return (<Draggable
												key={field.metafield_id}
												draggableId={field.meta_key}
												index={index}>
												{(provided, snapshot) => (
													<Card
														ref={provided.innerRef}
														{...provided.draggableProps}
														{...provided.dragHandleProps}
														style={getItemStyle(
															snapshot.isDragging,
															provided.draggableProps.style
														)}
													>
														<CardMedia
															className={classes.media}
															image={`${process.env.REACT_APP_API_SERVICE_URL}/fileuploads/${field.metafield_id}/preview/300/${field.filename}.png?token=${userContext.accessToken}`}
														/>
														<CardContent>
															<Tooltip title={field.file_title}>
																<Typography variant="caption" className={classes.cardTitle}>{field.file_title}</Typography>
															</Tooltip>
															<Tooltip title={field_group.group_name + " – " + field.file_field_label}>
																<Typography variant="caption">{field_group.group_name + " – " + field.file_field_label}</Typography>
															</Tooltip>
														</CardContent>
													</Card>
												)}
											</Draggable>);
										})}
													
										{provided.placeholder}
									</div>
								</>
							)}
						</Droppable>
					))}
				</DragDropContext>
			</AccordionDetails>
		</Accordion>
			
	);
}
